import React from 'react';
import { User } from '@phosphor-icons/react';
import './ProfileWidget.css';

const ProfileWidget = () => {
  // Get user data from localStorage
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const name = userData.name || 'Learner';
  const email = userData.email || '';
  const picture = userData.picture || '';

  return (
    <div className="profile-widget">
      <h3 className="profile-widget-title">Learner Profile</h3>
      
      <div className="profile-content">
        <div className="profile-avatar">
          {picture ? (
            <img src={picture} alt={name} className="avatar-image" />
          ) : (
            <div className="avatar-placeholder">
              <User size={40} weight="duotone" />
            </div>
          )}
        </div>
        
        <div className="profile-info">
          <h4 className="profile-name">{name}</h4>
          {email && <p className="profile-email">{email}</p>}
        </div>
      </div>
    </div>
  );
};

export default ProfileWidget;

